const SDK = {
    BASE_URL: "https://minimis.cloud",
    Token:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImVtYWlsIjoidGVzdEBleGFtcGxlLmNvbSJ9.q9d1HWpxYcHcDb9U8O0-ZKFi0kMDhVEoC8t6iHvYSHI",
    SOCKET_URL:"https://progstack.com",
    FRONTEND_DOMAIN:"https://pay.minimis.life"
  };
  
  export default SDK;
  